import { render, staticRenderFns } from "./ApprCompLst.vue?vue&type=template&id=53caae78&scoped=true"
import script from "./ApprCompLst.vue?vue&type=script&lang=js"
export * from "./ApprCompLst.vue?vue&type=script&lang=js"
import style0 from "./ApprCompLst.vue?vue&type=style&index=0&id=53caae78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53caae78",
  null
  
)

export default component.exports